import styled from 'styled-components';
import sunshineLoadingGif from './sunshineLoading.gif';

const ORIGINAL_SIZE = 420;

const StyledImg = styled.img<{$scale: number}>`
  display: block;
  margin: 0 auto;
  width: ${({$scale}) => `${ORIGINAL_SIZE * $scale}px`};
  height: ${({$scale}) => `${ORIGINAL_SIZE * $scale}px`};
`;

/** The cipx loading animation: a sun that draws on a smiley face. */
export function SunshineLoadingAnimation({scale = 1}: {scale?: number}) {
  return (
    <StyledImg
      className="sunshineAnimation"
      $scale={scale}
      src={sunshineLoadingGif}
      alt=""
    />
  );
}
